<template>
	<v-btn to="/myearning" rounded="pill" class="d-flex button-earning">

		<template v-slot:prepend>
			<v-icon>
				<coin-big></coin-big>
			</v-icon>
		</template>

		{{ userStore.user.coins_balance }}

	</v-btn>
</template>



<script setup lang="ts">

import CoinBig from "@/icons/CoinBig.vue";
import { useUserStore } from "../../store/UserStore";
const userStore = useUserStore();

</script>